import {
    LexicalNode
} from "lexical"

const debug = false
// const debug = "lexicalGetAncestor"

export function lexicalGetAncestor<NodeType extends LexicalNode = LexicalNode>(
    node        : LexicalNode,
    predicate   : (ancestor: LexicalNode) => ancestor is NodeType,
): null | LexicalNode {
    let parent: null | LexicalNode = node;
    while (
        parent !== null &&
        (parent = parent.getParent()) !== null &&
        !predicate(parent)
        ){}

    return parent
}